import { h2, paragraph, paragraphCss } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
import Favicon from "@/src/images/favicon-32x32.png";
import SwiperArrow from "@/src/images/swiper-arrow.svg";
import SwiperArrowMobile from "@/src/images/swiper-arrow-mobile.png";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 34px;

  @media screen and (${({ theme }) => theme.breakpoints.sm}) {
    margin-top: -20px;
    margin-bottom: 0px;
  }

  .mySwiper {
    width: 100%;
    height: 100%;
    padding-bottom: 40px;
  }
  .swiper-button-prev,
  .swiper-button-next {
    color: transparent;
  }

  .swiper-button-next {
    background-image: url(${SwiperArrow});

    @media screen and (max-width: 640px) {
      display: none;
    }
  }

  .swiper-button-prev {
    background-image: url(${SwiperArrow});
    transform: rotate(180deg);
    @media screen and (max-width: 640px) {
      display: none;
    }
  }

  .swiper-pagination-bullet {
    background-color: ${({ theme }) => theme.colors.pearlBush};
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background-color: ${({ theme }) => theme.colors.tango};
  }

  @media screen and (min-width: 820px) {
    .swiper-button-prev,
    .swiper-button-next {
      &.swiper-button-disabled {
        opacity: 0;
      }
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    }

    &:hover {
      .swiper-button-prev,
      .swiper-button-next {
        &.swiper-button-disabled {
          opacity: 0.3;
        }
        opacity: 1;
      }
    }
  }
`;

const Title = styled(h2)`
  margin-bottom: 20px;
`;

const Image = styled(GatsbyImage)`
  aspect-ratio: 16 / 9;
  width: 100%;
`;

const Video = styled.div`
  aspect-ratio: 16 / 9;
  width: 100%;
`;

const S = {
  Container,
  Title,
  Image,
  Video,
};

export default S;
